import { CesiumMapInputHandler } from 'app/map/services/map_input_handling/cesium_map_input_handler';
import { IMapInputHandler } from 'app/map/services/map_input_handling/MapInputHandler';
import { Cesium } from 'app/cesium';

export class CesiumMapInputHandlerCollection {
    private _cesiumMapHandlers: Array<{ name: string; handler: CesiumMapInputHandler }>;

    constructor() {
        this._cesiumMapHandlers = [];
    }

    public addCesiumMapHandler(mapInputHandler: IMapInputHandler): void {
        const handler = new CesiumMapInputHandler(mapInputHandler);

        this._cesiumMapHandlers.push({
            name: mapInputHandler.name,
            handler: handler,
        });
    }

    public activateCesiumMapHandler(
        mapInputHandler: IMapInputHandler,
        viewer: Cesium.Viewer,
    ): void {
        this._destroyAllCesiumMapHandlers();

        const handler = this._cesiumMapHandlers.find(
            (h) => h.name === mapInputHandler.name,
        ).handler;
        handler.create(viewer);

        // don't ask me why, I just copied it over when refactoring!
        if (mapInputHandler.isDefault) {
            handler.eventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
        }
    }

    private _destroyAllCesiumMapHandlers(): void {
        this._cesiumMapHandlers.forEach((h) => h.handler.destroy());
    }

    protected get cesiumMapHandlers(): Array<{ name: string; handler: CesiumMapInputHandler }> {
        return this._cesiumMapHandlers;
    }

    public removeCesiumMapHandler(mapInputHandler: IMapInputHandler): void {
        const index = this._cesiumMapHandlers.findIndex((c) => c.name === mapInputHandler.name);
        if (index !== -1) {
            this._cesiumMapHandlers.splice(index, 1);
        }
    }
}
